export default __webpack_public_path__ + "static/media/block-about-cards-1.84a02d26.webp";